module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step4-pict02-7dc8db8a3a59d560a91fb6e17519fa32.jpg";